import { combineReducers } from 'redux'

import edit from './edit'

export default combineReducers({
  edit,
})
